const passkey_sign_in = {
    setup_page: {
        title: 'Zjednoduš své přihlášení',
        subtitle: 'Vytvořit přístupový klíč',
        description: 'Zaregistruj svůj přístupový klíč pomocí biometrie zařízení, bezpečnostních klíčů (např. YubiKey) nebo jiných dostupných metod.',
    },
    trigger_conditional_ui_failed: 'Nepodařilo se spustit automatické vyplňování přístupového klíče.',
};
export default Object.freeze(passkey_sign_in);
